import React from 'react'
import PropTypes from 'prop-types'

function PromoCardsMol(props) {
    const {
        img, promoColor, promo, title, desc, promoText, btnTitle, btnLink, target_L,
        altImagen,
        titleImagen
    } = props
    return (
        <div className="cardPromo">
            <div className="cardPromoImg">
                <div className="promoBubbleWrap">
                    <span className={`promoBubble ${promoColor}`}>
                        <strong> {promo} </strong>
                    </span>
                </div>
                <picture>
                    <source alt={altImagen} title={titleImagen} srcSet={`${img.url}.webp`} type={`image/webp`} />
                    <source alt={altImagen} title={titleImagen} srcSet={`${img.url}.${img.ext}`} type={`image/${img.ext}`} />
                    <img src={`${img.url}.${img.ext}`} alt={altImagen} title={titleImagen} width="380" height="170" />
                </picture>
            </div>
            <div className="cardPromoCont">
                <div className="cardPromoTitle">
                    <h3 className="h5"> {title} </h3>
                    <p> {desc} </p>
                </div>
                {
                    promoText &&
                    <div className="cardPromoHighlight success">
                        <span>{promoText}</span>
                    </div>
                }
                {
                    btnTitle && target_L &&
                    <a className="btn btnBlancoRojo withIco" href={btnLink} target={target_L}>
                        <i className="ico-arrow-right"></i>
                        <span> {btnTitle}</span>
                    </a>
                }

                {
                    btnTitle && !target_L &&
                    <a className="btn btnBlancoRojo withIco" href={btnLink}>
                        <i className="ico-arrow-right"></i>
                        <span> {btnTitle}</span>
                    </a>
                }
                
            </div>
        </div>
    )
}

PromoCardsMol.defaultProps = {
    img: {
        origin: 'http://via.placeholder.com/450x200',
        webp: '',
        originM: '',
        webpM: '',
    }, 
    promoColor: 'rojo', 
    promo: '-30%', 
    title: 'Titulo', 
    desc: 'Con...', 
    promoText: 'Promoción válida solo ...',
    btnTitle: 'Ver Detalles',
    btnLink: '#'
}

PromoCardsMol.propTypes = {
    img: PropTypes.any,
    promoColor: PropTypes.string, 
    promo: PropTypes.string, 
    title: PropTypes.string, 
    desc: PropTypes.string, 
    promoText: PropTypes.string,
    btnTitle: PropTypes.string,
    btnLink: PropTypes.string,

}

export default PromoCardsMol
